import axios from 'axios';

// utils
import { mapErrorsToModel } from '@/utils/api';

export const storeLogo = async (menuId, logo) => {
  const formData = new FormData();
  formData.append('logo', logo);

  return axios({
    method: 'POST',
    url: `/api/menus/${menuId}/logos`,
    baseURL: '/',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      return response.data.logo;
    })
    .catch((error) => {
      if (error.response.status === 422) {
        return mapErrorsToModel(error.response.data.errors);
      }
    });
};
